import React from 'react';

const placeholderImage = '/images/GreenLoadingPixel.png';

const ImageDisplay = ({
                          imageBlob,
                          pic,
                          paddingTopPercent,
                          onPictureClick,
                      }) => (
    <div className="scrollable-image-container">
        <div className="scrollable-image-wrapper">
            <div
                className="image-blurred"
                style={{
                    backgroundImage: `url(${imageBlob || placeholderImage})`,
                    paddingTop: `${paddingTopPercent}%`,
                }}
            />
        </div>
        <div className={'floating-main-image-container'} onClick={onPictureClick}>
            <img
                src={imageBlob || placeholderImage}
                alt={pic.title}
                className="floating-main-image"
            />
        </div>
    </div>
);

export default ImageDisplay;